import React from "react";
import PropTypes from "prop-types";

export default function ArrowSVG(props) {
  const {
    styles: {
      height,
      width,
      fill
    }
  } = props;
  return (
    <svg
      id={props.id || ''}
      className={props.className || ''}
      height={height || "32px"}
      width={width || "32px"}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32" >
      <g id="Icon/Arrow/Down">
        <path
          d="M28.0026002,8 L32,11.7322932 L16.0104009,26.6614662 L16,26.651 L15.9895991,26.6614662 L3.1565861e-12,11.7322932 L3.99739978,8 L15.999,19.207 L28.0026002,8 Z"
          fill={fill || "#677383"}
        ></path>
      </g>
    </svg>
  );
}

ArrowSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};

ArrowSVG.defaultProps = {
  styles: {
    fill: "#677383",
    height: "32px",
    width: "32px"
  }
};
